module.exports = {"330122002":"旧县街道","330122003":"桐君街道","330122004":"城南街道","330122005":"凤川街道","330122101":"富春江镇","330122102":"横村镇","330122109":"分水镇","330122110":"瑶琳镇","330122112":"百江镇","330122113":"江南镇","330122201":"莪山畲族乡","330122202":"钟山乡","330122204":"新合乡","330122210":"合村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330122.json
// module id = 951
// module chunks = 0